import { fabric } from 'fabric';
import { castDraft } from 'immer';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { FabricState, SelectionWithAction } from './fabric.types';

import { SELECTION_CIRCLES } from '~/core/constants';
import { CircleAction } from '~/core/enums';

export const initialState: FabricState = {
  activeFreeDrawing: [],
  canvas: new fabric.Canvas(null),
  freeDrawMode: false,
  selectionCircles: {
    selection: SELECTION_CIRCLES.FOR_NONE,
    action: CircleAction.NONE,
  },
};

const fabricSlice = createSlice({
  name: 'fabric',
  initialState,
  reducers: {
    disposeCanvas: () => ({
      ...initialState,
    }),
    updateActiveFreeDrawing: (
      state,
      action: PayloadAction<FabricState['activeFreeDrawing']>
    ) => {
      state.activeFreeDrawing = action.payload;
    },
    updateCanvas: (state, action: PayloadAction<FabricState['canvas']>) => {
      state.canvas = castDraft(action.payload);
    },
    updateFreeDrawMode: (state, action: PayloadAction<boolean>) => {
      state.freeDrawMode = action.payload;
    },
    updateSelectionCircles: (
      state,
      action: PayloadAction<SelectionWithAction>
    ) => {
      state.selectionCircles = action.payload;
    },
  },
});

export default fabricSlice.reducer;

export const {
  disposeCanvas,
  updateActiveFreeDrawing,
  updateCanvas,
  updateFreeDrawMode,
  updateSelectionCircles,
} = fabricSlice.actions;
